exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\r\n  display: block;\r\n}\r\n\r\n.edit-spec-general-page {\r\n  padding: 24px;\r\n}\r\n\r\n.edit-spec-general-page__title {\r\n  margin: 0 0 16px;\r\n  font-size: 16px;\r\n  font-weight: 700;\r\n  color: var(--color-text, #212529);\r\n}\r\n\r\n.edit-spec-general-page__readonly {\r\n  border: 1px solid var(--color-border, #dee2e6);\r\n  border-radius: 6px;\r\n  background: #f8f9fa;\r\n  padding: 14px 16px;\r\n}\r\n\r\n.edit-spec-general-page__readonly h4,\r\n.edit-spec-general-page__readonly p {\r\n  margin: 0;\r\n}\r\n\r\n.edit-spec-general-page__readonly h4 {\r\n  font-size: 16px;\r\n  font-weight: 700;\r\n  line-height: 1.35;\r\n}\r\n\r\n.edit-spec-general-page__readonly p {\r\n  margin: 8px 0 0;\r\n  color: var(--color-text-muted, #6c757d);\r\n  font-size: 14px;\r\n  line-height: 1.5;\r\n}\r\n\r\n@media (max-width: 575px) {\r\n  .edit-spec-general-page {\r\n    padding: 16px;\r\n  }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/components/admin/edit-specialization-general-page/edit-specialization-general-page.component.css
// module id = ../../../../../src/app/content-page/common/skill-learning/components/admin/edit-specialization-general-page/edit-specialization-general-page.component.css
// module chunks = main